import { memo, type FC } from 'react';

import Typography from '../../../../Typography/index.ts';
import { TableNoDataImage } from './Image.tsx';
import { TableNoDataInnerWrapper, TableNoDataWrapper } from './styled.ts';
import type { TableNoDataProps } from './types.ts';

export const TableNoData: FC<TableNoDataProps> = memo(function TableNoData({
  className,
  message,
  action,
  image = <TableNoDataImage />,
  dataTestId,
}) {
  return (
    <TableNoDataWrapper className={className} data-testid={dataTestId ?? 'there-are-no-entries'}>
      <TableNoDataInnerWrapper>
        {image}
        <Typography.Title>{message}</Typography.Title>
        {action || null}
      </TableNoDataInnerWrapper>
    </TableNoDataWrapper>
  );
});
